import type { SkippedContentTypeRefreshField } from '../../../form/ContentObjectForm/helpers/contentTypeRefreshSnapshot';

import { Trans, useTranslation } from 'react-i18next';

type ContentTypeUpdatedModalContentProps = {
  skippedFields: SkippedContentTypeRefreshField[];
};

export const ContentTypeUpdatedModalContent = ({
  skippedFields,
}: ContentTypeUpdatedModalContentProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4">
      <p>
        <Trans i18nKey="ContentForm.ContentTypeUpdatedMessage" />
      </p>
      <p>
        <Trans i18nKey="ContentForm.ContentTypeUpdatedSaveInfo" />
      </p>
      {skippedFields.length > 0 && (
        <div className="rounded-md border border-orange-300 bg-orange-50 p-3 text-left text-sm text-orange-900">
          <p className="font-semibold">
            {t('ContentForm.ContentTypeUpdatedSkippedFieldsWarning')}
          </p>
          <ul className="mt-2 list-disc pl-5">
            {skippedFields.map(({ key, reason }) => (
              <li key={key}>
                {key} -{' '}
                {t(
                  `ContentForm.ContentTypeUpdatedSkippedFieldReasons.${reason}`,
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ContentTypeUpdatedModalContent;
